import { useMemo } from 'react'
import {
  useTranslation,
  useLocalizedUrl,
  HelpPage
} from '@sailogy/shipwright'
import { K } from './i18n'

interface Props {
  title: string
  active: 'about' | 'contact' | 'faq' | 'tec' | 'privacy' | 'cookies' | 'ouest' | 'yachtpool' | 'imprint' | 'careers'
}


const HelpContainer: React.FC<Props> = ({ title, active, children }) => {
  const t = useTranslation<K>()
  const localizedUrl = useLocalizedUrl()
  const menu = useMemo(() => [
    { href: localizedUrl('/help_contact'), label: t('Contact us'), active: active === 'contact' },
    { href: localizedUrl('/help_faq'), label: t('FAQs'), active: active === 'faq' },
    { href: localizedUrl('/help_tec'), label: t('Terms & Conditions'), active: active === 'tec' },
    { href: localizedUrl('/help_privacy'), label: t('Privacy Policy'), active: active === 'privacy' },
    { href: localizedUrl('/help_cookies'), label: t('Cookies'), active: active === 'cookies' },
    { href: localizedUrl('/help_imprint'), label: t('Imprint'), active: active === 'imprint' },
    { href: localizedUrl('/help_careers'), label: t('Work with us'), active: active === 'careers' }
  ], [t, localizedUrl])

  return (
    <HelpPage list={menu} title={title}>
      {children}
    </HelpPage>
  )
}

export default HelpContainer
